import React from 'react'

import { Table, Button } from '_zari/core'

const LetrasAsignadasTable = ({ letras, dispatch, flagControl }) => {
  const headRows = React.useMemo(() => {
    if (flagControl) {
      return [{ label: 'NRO' }, { label: 'IMPORTE' }, { label: 'F. VCTO' }, { label: 'DIAS' }, { label: '' }]
    }

    return [{ label: 'NRO' }, { label: 'IMPORTE' }, { label: 'F. VCTO' }, { label: 'DIAS' }]
  }, [flagControl])

  const clickEliminar = React.useCallback(
    ({ _idFila }) => {
      dispatch({ type: 'eliminar', payload: { _idFila } })
    },
    [dispatch]
  )

  return (
    <Table
      containerId='tabla-letras-sololectura'
      filas={letras}
      headRows={headRows}
      maxRowsShown={flagControl ? 5 : 3}
      rowTemplate={(row, k) => (
        <Table.Row key={k}>
          <Table.Cell align='center'>{row.numeroDocumento ?? '--'}</Table.Cell>
          <Table.Cell align='center'>{row.importe ?? '--'}</Table.Cell>
          <Table.Cell align='center'>{row.fechaVencimiento ?? '--'}</Table.Cell>
          <Table.Cell align='center'>{row.dias ?? '--'}</Table.Cell>
          {flagControl && (
            <Table.Cell align='center'>
              <Button color='danger' outline onClick={() => clickEliminar(row)} tiny>
                Eliminar
              </Button>
            </Table.Cell>
          )}
        </Table.Row>
      )}
    />
  )
}

export default React.memo(LetrasAsignadasTable)
